import React, { PureComponent, Children } from 'react';
import classNames from 'classnames';

import { isElementOfType } from '../../utilities/components';

import WpIcon from '../icon/WpIcon';
import WpButton from '../button/WpButton';

import './WpAlert.scss';

type Color = 'note' | 'info' | 'success' | 'warning' | 'danger';
const DEFAULT_TYPE = 'info';

type IconPlacement = 'center' | 'top';
const DEFAULT_ICON_PLACEMENT = 'top';

export interface Props {
  /**
   * Color of alert =>  Options: 'note' | info' | 'success' | 'warning' | 'danger';
   * @default 'info'
   */
  type?: Color;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  showIcon?: boolean;
  onDismiss?: Function;
  iconPlacement?: IconPlacement;
}

// TODO (@josh): future enhancement is to have a `closeable` prop that auto adds the close x
// and calls a function changing a local state of isVisible and closes the alert with an animation,
// then calls an afterClose callback if passed

class WpAlert extends PureComponent<Props> {
  render() {
    const {
      type = DEFAULT_TYPE,
      showIcon = true,
      icon,
      children,
      onDismiss,
      iconPlacement = DEFAULT_ICON_PLACEMENT,
    } = this.props;

    const getIcon = alertType => {
      switch (alertType) {
        case 'note':
        case 'info':
          return <WpIcon name="info-circle" />;
        case 'warning':
        case 'danger':
          return <WpIcon name="exclamation-circle" />;
        case 'success':
          return <WpIcon name="check-circle" />;
        default:
          return null;
      }
    };

    const iconLength = Children.count(icon);
    const customIcon = icon && icon && iconLength === 1 && isElementOfType(icon, WpIcon);

    const isIconVisible = showIcon;

    const classNamePrefix = 'WpAlert';
    const classes = classNames(classNamePrefix, `${classNamePrefix}--${type}`, `${classNamePrefix}--${iconPlacement}`);

    const iconClassNamePrefix = `${classNamePrefix}__icon`;
    const iconClasses = classNames(`${iconClassNamePrefix}`, `${iconClassNamePrefix}--${iconPlacement}`);

    return (
      <div className={classes} role="alert">
        <div className="WpAlert__content">
          {isIconVisible && <span className={iconClasses}>{customIcon ? icon : getIcon(type)}</span>}
          <div className="WpAlert__content__body">{children}</div>
        </div>
        {onDismiss && (
          <div className="WpAlert__close-btn">
            <WpButton size="sm" variant="tertiary" onClick={() => onDismiss()}>
              <WpIcon name="times" />
            </WpButton>
          </div>
        )}
      </div>
    );
  }
}

export default WpAlert;
